import * as React from 'react';
import * as moment from 'moment';
import { Card, Tag, Icon, Tooltip, IconAvatar } from '../';

interface Props {
  holiday: any;
  handleUpdate?: Function;
  currentDay?: any;
  link?: string | boolean;
}

/**
 * A singular holiday item used for archive views
 */
const HolidayItem = ({
  holiday,
  handleUpdate = () => {},
  currentDay = moment(),
  link = false,
}: Props) => {
  const start = moment(holiday.start).format('DD/MM/YY');
  const end = moment(holiday.end).format('DD/MM/YY');

  // Determine if hire ends today
  let endsToday = false;
  if (['ON-HOLD', 'COMPLETE'].indexOf(holiday.status) === -1) {
    endsToday =
      moment(holiday.end).format('YYYY-MM-DD') ===
      currentDay.format('YYYY-MM-DD');
  }

  const duration = 1 + moment(holiday.end).diff(moment(holiday.start), 'd');

  return (
    <Card list key={holiday.id} link={link} className="card--grey">
      <article className="media">
        <figure className="media-left has-text-centered">
          <IconAvatar icon="calendar" colour="#eeeeee" />
        </figure>
        <div className="media-content">
          <div className="content">
            <small className="has-text-grey">
              {start} - {end}
              {endsToday && (
                <>
                  {' '}
                  <Tooltip text="Finishes today">
                    <span className="has-text-danger">
                      <Icon icon="exclamation-triangle" />
                    </span>
                  </Tooltip>
                </>
              )}
            </small>
            <br />
            <strong>{holiday.name}</strong>
            <br />
            Holiday for {duration} day{duration !== 1 && 's'}
            {!!holiday.description && (
              <>
                <br />
                <small>{holiday.description}</small>
              </>
            )}
          </div>
        </div>
        <div className="media-right">
          <Tooltip text="Collection times are limited during this period">
            <Tag type="dark">HOLIDAY</Tag>
          </Tooltip>
        </div>
      </article>
    </Card>
  );
};

export default HolidayItem;
